/** Must match back-end SUBMISSION_RATE_LIMIT_* in submissionController.ts */
export const SUBMISSION_RATE_LIMIT_WINDOW_MS = 60_000;
export const SUBMISSION_RATE_LIMIT_MAX = 3;
